
// moment format to send to back end
const timePattern = 'HH:mm:ss.SSS';
const datePattern = 'YYYY-MM-DD';

const chartVenueAxisConfig = [
  { value: 'ARCA', name: 'ARCA', color: '#808080' },
  { value: 'CICF', name: 'CICF', color: '#f5564a' },
  { value: 'ECN', name: 'ECN', color: '#97c95c' },
  { value: 'Link ATS', name: 'LINK ATS', color: '#ffc720' },
  { value: 'IDQS', name: 'IDQS', color: 'black' }
];

const systemAckedTypes = [
  { id: true, value: 'Yes' },
  { id: false, value: 'No' }

];

export {
  timePattern, datePattern, chartVenueAxisConfig, systemAckedTypes
};
